import * as React from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  TextField,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
  Grid2,
  Paper,
  IconButton,
  Collapse,
} from "@mui/material";
import axios from "axios";
import { observer } from "mobx-react";
import styles from "./validateBankAc2.module.css";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessIcon from "@mui/icons-material/Business";
import NumbersIcon from "@mui/icons-material/Numbers";
import CloseIcon from "@mui/icons-material/Close";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import TagIcon from "@mui/icons-material/Tag";
import { useState } from "react";
import { useNavigate, useNavigationType } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect } from "react";
import store from "../../../Store/Store";
import config from "../../../config/config";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDebouncedLog } from "../../../useDebouncedLog";

const ValidateBankAc = observer(({ companyId }) => {
  const navigate = useNavigate();
  const [WalletInfo, setWalletinfo] = useState("Loading...");
  const [bankName, setBankName] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [kycCompanyId, setKycCompanyId] = useState(companyId);
  const [validatedRows, setValidatedRows] = useState([]);
  const [statusRows, setStatusRows] = useState([]); // [{date, amount, sourceName, accountNumber, status, reason}]
  const [sPage, setSPage] = useState(0);
  const [sRpp, setSRpp] = useState(5);
  const [showForm, setShowForm] = useState(false);
  const [open, setOpen] = useState(true);
  const navType = useNavigationType();
  const [submitting, setSubmitting] = React.useState(false);
  const [submittedOpen, setSubmittedOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [submitError, setSubmitError] = React.useState("");
  const [companyTempId, setCompanyTempId] = useState("");
  const [errors, setErrors] = useState({
    bankName: "",
    ifsc: "",
    accountNumber: "",
  });
  console.log("companyId", companyId);
  console.log("this is ValidateBank AC2-------------------------------");
  // validated source accounts
  const [vPage, setVPage] = useState(0);
  const [vRpp, setVRpp] = useState(5);

  // money load accepted
  const [aPage, setAPage] = useState(0);
  const [aRpp, setARpp] = useState(5);

  // money load rejected
  const [rPage, setRPage] = useState(0);
  const [rRpp, setRRpp] = useState(5);

  const [whitelistingErr, setWhitelistingErr] = useState("");
  const [latest, setLatest] = useState(null);
  const [rejectedLoad, setRejectedLoad] = useState(null);
  const [acceptedLoad, setAcceptedLoad] = useState(null);
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  let tokens = localStorage.getItem("authToken");
  let parsedTokens = JSON.parse(tokens);
  const BASE_URL = "http://localhost:5050";

  var logMoneyLoadVisited;
  var logMoneyLoadRejectedFetched;
  var logMoneyLoadAcceptedFetched
  try {
    logMoneyLoadVisited = useDebouncedLog("admin_money_load_visited", 500);
    logMoneyLoadRejetedFetched = useDebouncedLog("admin_money_load_fetched", 500);
    logMoneyLoadAcceptedFetched = useDebouncedLog("admin_money_load_accepted_fetched", 500);
  } catch (err) {
    console.log("error", err);
  }

  useEffect(() => {
    if (store.userType == "AxisUser") {
      navigate("/content/transactions");
    }
  }, [store.refresh, store.Company_Id]);
  useEffect(() => {
    logMoneyLoadVisited()
    setKycCompanyId(store.KycCompanyId ? store.KycCompanyId : companyId);
  }, [logMoneyLoadVisited]);

  useEffect(() => {
    setCompanyTempId(kycCompanyId);
  }, [store.refresh]);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        const res = await fetch(
          `${config.kyc_api_endpoint}/basic-kyc/by-company`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedTokens.IdToken,
              aws_cognito_access_token: parsedTokens.AccessToken,
            },
            body: JSON.stringify({ company_id: kycCompanyId }),
          },
        );

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const data = await res.json();
        setCompanyName(data.data.Company_Name);
      } catch (error) {
        console.log("Error fetching KYC data:", error);
      }
    };

    if (kycCompanyId) {
      fetchData();
    }
  }, [store.refresh, kycCompanyId, config.kyc_api_endpoint]);

  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    let parsedTokens = JSON.parse(auth);
    const expired = isTokenExpired(parsedTokens.IdToken);
    if (expired) {
      parsedTokens = getNewTokens(parsedTokens);
    }
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_rejected_inwards`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: {
        ledger_label: store.Company_Id,
        last_no_of_days: 180,
      },
    };

    axios
      .request(payload)
      .then((res) => {
        try {
          logMoneyLoadRejetedFetched();
        } catch (err) {
          console.log("error", err);
        }
        setRejectedLoad(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [store.refresh, store.Company_Id]);
  
  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_credited_inwards`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: {
        ledger_label: store.Company_Id,
        last_no_of_days: 180,
      },
    };

    axios
      .request(payload)
      .then((res) => {
        try {
          logMoneyLoadAcceptedFetched();
        } catch (err) {
          console.log("error", err);
        }
        setAcceptedLoad(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [store.refresh, store.Company_Id]);

  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    let parsedTokens = JSON.parse(auth);
    const expired = isTokenExpired(parsedTokens.IdToken);
    if (expired) {
      parsedTokens = getNewTokens(parsedTokens);
    }

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_white_listed_accounts`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: {
        ledger_label: store.Company_Id,
      },
    };

    axios
      .request(payload)
      .then((res) => {
        setLatest(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [store.refresh, store.Company_Id]);

  useEffect(() => {
    if (!tokens) {
      console.log("no auth");
      navigate("/login");
      return;
    } else {
    }
    try {
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_company_detail`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: {
          ledger_label: store.Company_Id,
        },
      };

      axios
        .request(payload)
        .then((res) => {
          setWalletinfo(res.data.data);
        })
        .catch((er) => {
          console.log("error-->", er);
        });
    } catch (err) {
      console.log("Error in walletInfo", err);
    }
  }, [store.refresh]);

  const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/; // length 11, ex: UTIB0XXXXX
  const ACC_REGEX = /^[0-9]{6,20}$/;
  function validateField(name, value) {
    let msg = "";
    if (name === "bankName") {
      if (!value) msg = "Bank name is required";
      else if (value.length < 2) msg = "Enter a valid bank name";
    } else if (name === "ifsc") {
      if (!value) msg = "IFSC is required";
      else if (!IFSC_REGEX.test(value))
        msg = "Enter a valid IFSC (e.g., UTIB0XXXXX)";
    } else if (name === "accountNumber") {
      if (!value) msg = "Account number is required";
      else if (!ACC_REGEX.test(value)) msg = "6–20 digits only";
    }
    setErrors((p) => ({ ...p, [name]: msg }));
    return !msg;
  }

  function validateAll() {
    // const ok1 = validateField("bankName", bankName);
    const ok2 = validateField("ifsc", ifsc);
    const ok3 = validateField("accountNumber", accountNumber);
    return /* ok1 && */ ok2 && ok3;
  }

  // const toggle = () => setOpen((s) => !s);
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      // toggle();
    }
  };
  const handleSubmit = async () => {
    try {
      setWhitelistingErr("");
      setSubmitting(true);
      setSubmitError("");

      const IFSC = (ifsc || "").trim().toUpperCase();
      const ACC_NO = (accountNumber || "").trim();

      const payload = {
        ifsc: IFSC,
        acc_no: ACC_NO,
        company_id: kycCompanyId,
        company_name: companyName,
        ledger_label: store.Company_Id,
      };

      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const res = await axios
        .post(`${config.kyc_api_endpoint}/bank-account-verify`, payload, {
          // timeout: 15000,
          headers: {
            aws_cognito_id_token: parsedTokens.IdToken,
            aws_cognito_access_token: parsedTokens.AccessToken,
          },
          validateStatus: () => true,
        })
        .then(async (res) => {
          if (res.data.verified == false || res.data.status == "unverified") {
            setWhitelistingErr(
              "We couldn’t verify your bank account. Please double-check your IFSC and account number and try again.",
            );
          }

          if (res.data.status == "timeout") {
            setWhitelistingErr(
              "The verification took too long. Please re-enter your account details and try again.",
            );
          }
          if (res.data.status == "duplicate") {
            setWhitelistingErr(res.data.message + "");
          }
          if (res.data.status === "approved") {
            let whitelistResponse;

            try {
              whitelistResponse = await axios.post(
                `${config.node_api_endpoint}/cupi/admin/add_whitelisting_to_master_account`,
                {
                  ledger_label: store.Company_Id,
                  bank_account_no: ACC_NO,
                  bank_ifsc: IFSC,
                  account_name: res.data.beneficiary_name,
                },
                {
                  headers: {
                    aws_cognito_id_token: parsedTokens.IdToken,
                    aws_cognito_access_token: parsedTokens.AccessToken,
                    "Content-Type": "application/json",
                  },
                  timeout: 15000,
                  validateStatus: () => true,
                },
              );

              if (whitelistResponse.data.status === 200) {
                setSubmittedOpen(true);
                setRefresh(!refresh);
                setBankName("");
                setIfsc("");
                setAccountNumber("");
                return;
              }
            } catch (err) {
              console.log("Error calling whitelist API:", err.message);
            }
          }
          if (res.data.verified && res.status === 200) {
            setSubmittedOpen(true);
            setRefresh(!refresh);
            setBankName("");
            setIfsc("");
            setAccountNumber("");
            return;
          }
          setRefresh(!refresh);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log("error-->", err);
    } finally {
      setSubmitting(false);
    }
  };

  function toValidatedRows(list) {
    const arr = Array.isArray(list) ? list : [];
    return arr
      .slice()
      .sort(
        (a, b) => new Date(b?.created_at || 0) - new Date(a?.created_at || 0),
      )
      .map((r) => ({
        date: r?.created_at ? new Date(r.created_at).toLocaleDateString() : "—",
        accountNumber: r?.bank_account ?? "—",
        ifsc: r?.full_ifsc ?? "—",
        beneficiary_name: r?.account_name ?? "—",
      }));
  }

  function toValidatedRowsRejected(list) {
    const arr = Array.isArray(list) ? list : [];
    return arr
      .slice()
      .sort(
        (a, b) => new Date(b?.created_at || 0) - new Date(a?.created_at || 0),
      )
      .map((r) => ({
        date: r?.inward_timestamp ?? "—",
        accountNumber: r?.sender_bank_account_no ?? "—",
        sourceAccountName: r?.sender_bank_account_name ?? "—",
        amount: r?.amount ?? "—",
        status: r?.status ?? "Rejected",
        reason:
          r?.reason ?? `Source A/c name and Company Bank A/c name don’t match.`,
        ifsc: r?.ifsc ?? "—",
        utr: r?.utr ?? "-",
      }));
  }

  const prettySvcStatus = (code = "") => {
    const map = {
      FUNDS_RECEIVED_CREDIT_ALLOCATION_PENDING:
        "Funds received — wallet load in progress.",
      FUNDS_RECEIVED_CREDIT_PASSED: "Wallet loaded successfully.",
    };

    // Fallback: prettify unknown enum codes like "SOME_STATUS" -> "Some status"
    if (map[code]) return map[code];
    return String(code)
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/^\w/, (c) => c.toUpperCase());
  };
  function toValidatedRowsAccepted(list) {
    const arr = Array.isArray(list) ? list : [];

    return arr
      .slice()
      .sort(
        (a, b) => new Date(b?.created_at || 0) - new Date(a?.created_at || 0),
      )
      .map((r) => ({
        date: r?.timestamp_when_credit_given_to_corporate_wallet,
        amount: r?.amount ?? "—",
        sourceAccountName: r?.sender_name ?? "—",
        accountNumber: r?.sender_account_no ?? "—",
        ifsc: r?.sender_ifsc ?? "—",
        status: prettySvcStatus(r?.svc_load_status),
        utr: r?.utr_visible_to_client ?? "-",
        reason: r?.reason ?? "Source A/c name and Company Bank A/c name match.",
      }));
  }

  const formValid =
    !errors.bankName &&
    !errors.ifsc &&
    !errors.accountNumber &&
    bankName &&
    ifsc &&
    accountNumber;

  return (
    <div style={{ marginLeft: "15px", width: "95%", marginTop: "20px" }}>
      <Dialog
        open={submittedOpen}
        onClose={() => setSubmittedOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Details Submitted
          <IconButton
            aria-label="close"
            onClick={() => setSubmittedOpen(false)}
            edge="end"
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            pb: 3, // add some bottom padding since we removed DialogActions
          }}
        >
          <Typography align="center" sx={{ color: "text.secondary" }}>
            Once validated, the bank account details will show up in the list
            below.
          </Typography>
        </DialogContent>
      </Dialog>

      <DataTable
        title="Money Load Accepted"
        columns={[
          { key: "date", label: "Date" },
          { key: "amount", label: "Amount" },
          { key: "sourceAccountName", label: "Source account name" },
          { key: "accountNumber", label: "Account number" },
          // { key: "ifsc", label: "IFSC" },
          { key: "status", label: "Status" },
          { key: "reason", label: "Reason" },
          { key: "utr", label: "UTR" },
        ]}
        rows={toValidatedRowsAccepted(acceptedLoad)}
        page={aPage}
        rowsPerPage={aRpp}
        onPageChange={(e, p) => setAPage(p)}
        onRowsPerPageChange={(e) => {
          setARpp(parseInt(e.target.value, 10));
          setAPage(0);
        }}
        sx={{ width: "100%" }}
        emptyMessage="No accepted transactions yet."
      />

      <div style={{ marginTop: "15px" }}></div>
      <DataTable
        title="Money Load Rejected"
        columns={[
          { key: "date", label: "Date" },
          { key: "amount", label: "Amount" },
          { key: "sourceAccountName", label: "Source account name" },
          { key: "accountNumber", label: "Account number" },
          // { key: "ifsc", label: "IFSC" },
          { key: "status", label: "Status" },
          { key: "reason", label: "Reason" },
          { key: "utr", label: "UTR" },
        ]}
        rows={toValidatedRowsRejected(rejectedLoad)}
        page={rPage}
        rowsPerPage={rRpp}
        onPageChange={(e, p) => setRPage(p)}
        onRowsPerPageChange={(e) => {
          setRRpp(parseInt(e.target.value, 10));
          setRPage(0);
        }}
        sx={{ width: "100%" }}
        emptyMessage="No rejected transactions yet."
      />
      <Box sx={{ p: { xs: 2, md: 3 }, /* maxWidth: 1100, */ mx: "auto" }}>
        <Box
          role="button"
          tabIndex={0}
          // onClick={toggle}
          onKeyDown={onKey}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 1,
            cursor: "pointer",
          }}
          aria-expanded={open}
          aria-controls="load-account-details"
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              letterSpacing: 0.2,
              position: "relative",
              pb: 1,
              display: "inline-block",
              width: "max-content",
              "&::after": {
                content: '""',
                position: "absolute",
                left: 0,
                right: 0, // underline matches text width
                bottom: 0,
                height: 2,
                bgcolor: "divider",
              },
            }}
          >
            Load Account Details (Transfer money to this account)
          </Typography>

          {/* <IconButton
            size="small"
            aria-label={open ? "Collapse" : "Expand"}
            sx={{
              ml: 0.5,
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 200ms",
            }}
          >
            <ExpandMoreIcon />
          </IconButton> */}
        </Box>

        {/* Collapsible content */}
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box id="load-account-details">
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                mb: 0.5,
                lineHeight: 1.2,
                fontWeight: "bold",
                fontSize: "20px",
                fontFamily: "sans-serif",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                color: "#4C4E64",
              }}
            >
              <img
                alt={"image"}
                src={"/alert-circle.svg"}
                style={{ height: "24px", width: "24px" }}
              />{" "}
              Transfer money from {store.companyName} /{" "}
              {store.tradeName ? store.tradeName : store.companyName} bank
              account only. Only IMPS, NEFT, RTGS, FT loads are accepted. UPI is
              not accepted.
            </Typography>
            {/* Bank details in aligned rows */}
            <Grid2 spacing={0.5} sx={{ mb: 2, mt: 2 }}>
              <DetailRow label="Ac.name" value={store.companyName} />
              <DetailRow
                label="Ac.no"
                value={WalletInfo?.van?.acc_no || "Loading..."}
              />
              <DetailRow
                label="IFSC"
                value={WalletInfo?.van?.ifsc || "Loading..."}
              />
              <DetailRow label="Branch" value="CC HUB" />
              <DetailRow label="Bank name" value="Axis Bank" />
            </Grid2>
          </Box>
        </Collapse>
        {/* Notes paragraph + bullets */}
        <Box sx={{ mt: 2 }}>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 0.5,
              lineHeight: 1.8,
              fontWeight: "bold",
              color: "#4C4E64",
            }}
          >
            Please avoid loading money between 11:00 pm and 1:00 am as Bank
            servers are undergo End of Day processes and are unreliable during
            this time.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 0.5,
              lineHeight: 1.8,
              fontWeight: "bold",
              color: "#4C4E64",
            }}
          >
            After we receive the funds, your wallet balance may update within 30
            minutes to 2 hours due to batch processing
          </Typography>

          <Box
            component="ul"
            sx={{ m: 0, pl: 3, color: "text.secondary", listStyleType: "disc" }}
          >
            <li>
              <Typography variant="body2">
                NEFT and RTGS transfers may be delayed if you send them during
                bank holidays or outside bank working hours.
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                In those cases, the money will show up on the next working day.
              </Typography>
            </li>
            {/* <li>
              <Typography variant="body2">
                Please load money only from your Whitelisted Source Bank
                Accounts" to your VAN: ESTA28233124 IFSC: UTIB0CCH274
              </Typography>
            </li> */}
          </Box>
        </Box>
        {/* How it works */}
        <Box sx={{ mb: 3, mt: 3, color: "#4C4E64" }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1 }}>
            How it works:
          </Typography>

          <Box component="ol" sx={{ pl: 3, m: 0 }}>
            <Typography component="li" variant="body1" sx={{ mb: 1.5 }}>
              You can only add money from your{" "}
              <strong>
                {store.companyName} /{" "}
                {store.tradeName ? store.tradeName : store.companyName}
              </strong>{" "}
              bank account.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 1.5 }}>
              If you use a different account, the transfer will be rejected. So,
              it’s best to stick with your company account.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 1.5 }}>
              We automatically check where the money is coming from, so you try
              to transfer Rs.1 to see if it gets loaded and if it does not, then
              try <strong>step 4.</strong>
            </Typography>
            <Typography component="li" variant="body1">
              You can also add and verify your bank account details below to
              make sure everything works perfectly when you transfer.
            </Typography>
          </Box>
        </Box>
        <div style={{ marginTop: "15px" }}></div>
        <div className={styles.split}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "text.primary" }}
          >
            Add and verify your company account details
          </Typography>
          {!store.isUserViewAdmin && !store.isUserGlobalViewAdmin ? (
            <Button
              variant="contained"
              size="medium"
              sx={{
                bgcolor: "#2348AB",
                "&:hover": { bgcolor: "#3f55c7" },
                textTransform: "none",
                borderRadius: 2,
                px: 5,
                fontWeight: 700,
              }}
              onClick={() => setShowForm(!showForm)}
              // DO NOT toggle here; fields only show on back
            >
              Add
            </Button>
          ) : (
            <Button
              variant="contained"
              size="medium"
              sx={{
                bgcolor: "#2348AB",
                "&:hover": { bgcolor: "#3f55c7" },
                textTransform: "none",
                borderRadius: 2,
                px: 5,
                fontWeight: 700,
                opacity: 0.45,
                cursor: "default",
              }}
              // DO NOT toggle here; fields only show on back
            >
              Add
            </Button>
          )}
        </div>

        {showForm && (
          <Grid2
            container
            alignItems="center"
            justifyContent="space-between"
            rowSpacing={2}
            columnSpacing={2}
            sx={{ mb: 2, mt: 1 }}
          >
            {/* Bank name (auto UPPERCASE) */}
            {/* <Grid2
              xs={12}
              md="auto"
              sx={{ flex: { md: "1 1 32%" }, minWidth: { md: 260 } }}
            >
              <TextField
                fullWidth
                label="Bank name"
                value={bankName}
                onChange={(e) => {
                  // allow letters, spaces & a few punctuation; force UPPERCASE
                  const v = e.target.value
                    .toUpperCase()
                    .replace(/[^A-Z .&()/-]/g, "");
                  setBankName(v);
                  if (errors.bankName) validateField("bankName", v);
                }}
                onBlur={() => validateField("bankName", bankName)}
                error={Boolean(errors.bankName)}
                helperText={errors.bankName || " "}
                sx={{ "& input": { textTransform: "uppercase" } }}
              />
            </Grid2> */}

            {/* IFSC (auto UPPERCASE, 11 chars, A-Z0-9 only) */}
            <Grid2
              xs={12}
              md="auto"
              sx={{ flex: { md: "1 1 32%" }, minWidth: { md: 260 } }}
            >
              {" "}
              <TextField
                fullWidth
                label="Account number"
                value={accountNumber}
                onChange={(e) => {
                  const v = e.target.value.replace(/\D/g, "").slice(0, 20);
                  setAccountNumber(v);
                  if (errors.accountNumber) validateField("accountNumber", v);
                }}
                onBlur={() => validateField("accountNumber", accountNumber)}
                error={Boolean(errors.accountNumber)}
                helperText={errors.accountNumber || " "}
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  maxLength: 20,
                }}
              />
            </Grid2>

            {/* Account number (digits only) + Submit */}
            <Grid2
              xs={12}
              md="auto"
              sx={{
                flex: { md: "1 1 32%" },
                minWidth: { md: 320 },
                display: "flex",
                gap: 2,
              }}
            >
              <TextField
                fullWidth
                label="IFSC"
                value={ifsc}
                onChange={(e) => {
                  const v = e.target.value
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, "")
                    .slice(0, 11);
                  setIfsc(v);
                  if (errors.ifsc) validateField("ifsc", v);
                }}
                onBlur={() => validateField("ifsc", ifsc)}
                error={Boolean(errors.ifsc)}
                helperText={errors.ifsc || " "}
                inputProps={{ maxLength: 11 }}
                sx={{
                  "& input": { textTransform: "uppercase", letterSpacing: 1 },
                }}
              />

              <Button
                variant="contained"
                onClick={async () => {
                  if (!validateAll()) return;
                  await handleSubmit(); // your existing submit
                }}
                sx={{
                  px: 3,
                  borderRadius: 2,
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  backgroundColor: "#2348AB",
                  height: "55px",
                }}
              >
                Submit
              </Button>
            </Grid2>
          </Grid2>
        )}

        {whitelistingErr && (
          <span
            style={{
              color: "#B20A00",
              fontSize: "20px",
              marginBottom: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {whitelistingErr}
          </span>
        )}
        {!whitelistingErr && submitError && (
          <span
            style={{
              color: "#B20A00",
              fontSize: "20px",
              marginBottom: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {submitError}
          </span>
        )}

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 1,
            fontSize: "24px",
            color: "#4C4E64",
            paddingTop: "5px",
          }}
        >
          Below is the list of validated and whitelisted source account(s) from
          which you can load your CUPI wallet.
        </Typography>
        <DataTable
          title="Validated Source Accounts"
          columns={[
            { key: "accountNumber", label: "Account Number" },
            { key: "ifsc", label: "IFSC" },
            { key: "beneficiary_name", label: "Account Name" },
          ]}
          rows={toValidatedRows(latest)}
          page={vPage}
          rowsPerPage={vRpp}
          onPageChange={(e, p) => setVPage(p)}
          onRowsPerPageChange={(e) => {
            setVRpp(parseInt(e.target.value, 10));
            setVPage(0);
          }}
          sx={{ width: "50%" }}
          emptyMessage={
            loading
              ? "Loading…"
              : "Please validate your source account to get started."
          }
        />
      </Box>
    </div>
  );
});

/** --- Helpers --- **/

function DetailRow({ label, value }) {
  return (
    <Grid2 item xs={12} sm={12} md={12}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "120px 8px 1fr", sm: "150px 8px 1fr" },
          alignItems: "baseline",
          columnGap: 1,
          py: 0.25,
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: "text.secondary", whiteSpace: "nowrap" }}
        >
          {label}
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          :
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 400 }}>
          {value}
        </Typography>
      </Box>
    </Grid2>
  );
}

function SectionHeader({ title, sx }) {
  return (
    <Box
      sx={{ ...sx, borderBottom: 1, borderColor: "divider", mb: 1.5, pb: 1 }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
        {title}
      </Typography>
    </Box>
  );
}

function DataTable({
  title,
  subtitle,
  headerRight, // optional: actions (buttons, chips, etc.)
  columns,
  rows,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  emptyMessage = "No data",
  renderCell,
  sx,
}) {
  const paginated = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <Box
      sx={{
        border: 1,
        borderColor: "divider",
        borderRadius: 2,
        overflow: "hidden", // keep header/table/pagination visually attached
        ...sx,
      }}
    >
      {/* Attached header */}
      {(title || subtitle || headerRight) && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            p: 2,
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <Box>
            {title && (
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 800, lineHeight: 1.2 }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mt: 0.5 }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          {headerRight || null}
        </Box>
      )}

      <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 0 }}>
        <Table size="small" aria-label="data table">
          <TableHead>
            <TableRow>
              {columns.map((c) => (
                <TableCell key={c.key} sx={{ fontWeight: 700 }}>
                  {c.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {paginated.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  sx={{ py: 6 }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 1,
                      color: "text.secondary",
                    }}
                  >
                    <InfoOutlinedIcon fontSize="small" />
                    <Typography variant="body2">{emptyMessage}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              paginated.map((row, idx) => (
                <TableRow key={idx}>
                  {columns.map((c) => (
                    <TableCell key={c.key}>
                      {renderCell
                        ? renderCell(c, row[c.key])
                        : c.key == "reason"
                          ? title == "Money Load Accepted"
                            ? "Source A/c name and Company Bank A/c name match."
                            : title == "Money Load Rejected"
                              ? `Source A/c name and Company Bank A/c name don’t match.
              (Please call customer service, if this was a mistake. )`
                              : (row[c.key] ?? "—")
                          : (row[c.key] ?? "—")}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Divider />

      <TablePagination
        component="div"
        count={rows.length}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 20]}
        labelRowsPerPage="Rows per page:"
        sx={{ px: 2 }}
      />
    </Box>
  );
}
export default ValidateBankAc;
